export default "__VITE_ASSET__Vgc9PMtj__"